let initialState = {
  customAttributeEditData: {}, //Edit Response
  customModalVisible: false, //Set custom modal visibility
  createCustomColumnStatus: null,
  deleteCustomColumnStatus: null,
  updateCustomColumnStatus: null,
  deleteCustomModalVisible: false,
  deleteCustomColumn: null,
  customSearch: "",
  createCustomColumn: null,
  updateCustomColumn: null,
  saveLoader: {
    attribute: null,
    value: false,
    type: null,
    id: null,
  },
  deleteLoader: {
    attribute: null,
    value: false,
  },
  progressBar: 1,
};

const customAttribute = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CUSTOM_ATTRIBUTE_EDIT_DATA":
      return {
        ...state,
        customAttributeEditData: action.payload,
      };

    case "SET_CUSTOM_MODAL_VISIBLE":
      return {
        ...state,
        customModalVisible: action.payload,
      };
    case "SET_CLEAR_CUSTOM_MODAL_VISIBLE":
      return {
        ...state,
        customModalVisible: action.payload,
      };
    case "SET_CUSTOM_ATTRIBUTE_CLEAR_ALL":
      return initialState;
    case "SET_CREATE_CUSTOM_COLUMN_STATUS":
      return {
        ...state,
        createCustomColumnStatus: action.payload,
      };
    case "SET_DELETE_CUSTOM_COLUMN_STATUS":
      return {
        ...state,
        deleteCustomColumnStatus: action.payload,
      };
    case "SET_UPDATE_CUSTOM_COLUMN_STATUS":
      return {
        ...state,
        updateCustomColumnStatus: action.payload,
      };
    case "SET_CREATE_CUSTOM_COLUMN_STATUS_CLEAR":
      return {
        ...state,
        createCustomColumnStatus: action.payload,
      };
    case "SET_DELETE_CUSTOM_COLUMN_STATUS_CLEAR":
      return {
        ...state,
        deleteCustomColumnStatus: action.payload,
      };
    case "SET_UPDATE_CUSTOM_COLUMN_STATUS_CLEAR":
      return {
        ...state,
        updateCustomColumnStatus: action.payload,
      };
    case "SET_DELETE_CUSTOM_MODAL_VISIBLE":
      return {
        ...state,
        deleteCustomModalVisible: action.payload,
      };
    case "SET_CUSTOM_COLUMN_DELETE":
      return {
        ...state,
        deleteCustomColumn: action.payload,
      };
    case "SET_CREATE_CUSTOM_COLUMN":
      return {
        ...state,
        createCustomColumn: action.payload,
      };
    case "SET_UPDATE_CUSTOM_COLUMN":
      return {
        ...state,
        updateCustomColumn: action.payload,
      };
    case "SET_CUSTOM_ATTRIBUTE_LOADER":
      return {
        ...state,
        saveLoader: action.payload,
      };
    case "SET_CUSTOM_ATTRIBUTE_DELETE_LOADER":
      return {
        ...state,
        deleteLoader: action.payload,
      };
    case "SET_CUSTOM_ATTRIBUTE_PROGRESS_LOADER":
      return {
        ...state,
        progressBar: action.payload,
      };
    case "SET_SEARCH":
      return {
        ...state,
        customSearch: action.payload,
      };
    default:
      return state;
  }
};

export default customAttribute;
